module.exports = __webpack_public_path__ + "media/images/video_sprites-c8cc70033001da076c15c54897ecd177.png";